import script from "./dashbExprCcl.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashbExprCcl.vue?vue&type=script&setup=true&lang=ts"

import "./dashbExprCcl.vue?vue&type=style&index=0&id=766c55cc&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766c55cc"]])

export default __exports__